import { computed, toValue } from 'vue'

import type { ComputedRef, MaybeRefOrGetter } from 'vue'
import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'

import { TutorAction } from '@brighterly/lib-core-types/booking/enums'

interface LessonRoomBookingReturn {
  nearpodCode: ComputedRef<string | null>
}

export const useLessonRoomBooking = (booking: MaybeRefOrGetter<Booking | null>): LessonRoomBookingReturn => {
  const nearpodCode = computed<string | null>(() => {
    const action = toValue(booking)?.tutor_action
    if (!action) return null
    return (action[TutorAction.NearpodShare] as string | null) || null
  })

  return {
    nearpodCode,
  }
}
